import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import {
    Checkbox, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TableSortLabel, TablePagination, TableFooter
} from '@mui/material';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import { fetchData, deleteData, activateData, updateData, SyncData, postData, DespatchData, ReportData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Tooltip, Snackbar, Alert } from '@mui/material';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Select from 'react-select';
import { useParams, useHistory } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import * as XLSX from 'xlsx';
import CircularProgress from '@mui/material/CircularProgress';
import { MenuItem } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';

function ChequeStatus() {
    const history = useHistory();
    const [data, setData] = useState([]);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('itemWise');
    const [isFocused, setIsFocused] = useState(false);
    const [loading, setLoading] = useState(false);
    const [MenuItem, setMenuItem] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }
        // Token is not expired, fetch data
        setFromDate(getMonthStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        fetchRouteTypes();
        fetchCustomers();
        fetchSTypes();
    }, [isAuthenticated, companyId, userId, token, logout]);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getMonthStartDate = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Ensure 2-digit month
        return `${year}-${month}-01`; // Format as 'YYYY-MM-DD'
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };


    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };
    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );
    useEffect(() => {
        const initialSelectedStatusType = data.reduce((acc, row) => {
            acc[row.paymentid] = row.chequeStatus; // Set initial value to chequeStatus
            return acc;
        }, {});
        setSelectedStatusType(initialSelectedStatusType);
    }, [data]);


    const [selectedStatusType, setSelectedStatusType] = useState("");

    const [statusId, setstatusId] = useState('0');
    const [selectedStatus, setSelectedStatus] = useState("");
    const [statusOptions, setStatusOptions] = useState([]);
    // const [selectedStatusType, setSelectedStatusType] = useState("");

    const fetchSTypes = async () => {
        try {
            const id = 0;  // Ensure statusId is set properly
            const response = await fetchData('ChequeSummaryAPI', `/${id}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(status => ({
                    value: status.Id,
                    label: status.Status
                }));
                setStatusOptions(options);
            } else {
                console.error('Failed to fetch status types');
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const [fineAmounts, setFineAmounts] = useState({});

    const handleStatusTypeChange = (selectedOption, paymentid) => {
        // Prevent status change if chequefine > 0
        const row = processedData.find((row) => row.paymentid === paymentid);
        if (row?.chequefine > 0) {
            alert("Status cannot be changed... Fine already saved  ");
            return;
        }

        // Update the status type
        setSelectedStatusType((prev) => ({
            ...prev,
            [paymentid]: {
                value: selectedOption.value, // Store statusId
                label: selectedOption.label, // Store status label
            },
        }));

        // Clear fine amount if the status label is not "Rejected"
        if (selectedOption.label !== 'Rejected') {
            setFineAmounts((prev) => {
                const updated = { ...prev };
                delete updated[paymentid];
                return updated;
            });
        }
    };

    const handleFineAmountChange = (paymentid, value) => {
        setFineAmounts((prev) => ({
            ...prev,
            [paymentid]: value,
        }));
    };

    // Route Selection -Filter


    const [routeOptions, setRouteOptions] = useState([]);
    const [selectedRoute, setSelectedRoute] = useState(null);
    const [routeId, setrouteid] = useState('0');
    //FOR GET Route  Details FROM API
    const fetchRouteTypes = () => {
        fetchData('RouteApi', `/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                // Transform the data into the format that react-select expects (label and value)
                const options = data.map((route) => ({
                    label: route.name,
                    value: route.id,
                }));
                setRouteOptions(options);
            })
            .catch((error) => {
                console.error('Error fetching route data:', error);
            });
    };

    const handleRouteSelect = (selectedOption) => {
        setSelectedRoute(selectedOption);  // Set the selected option as state
        const routeId = selectedOption ? selectedOption.value : '';  // Extract executiveId from the selected option
        setrouteid(routeId);  // Set executiveId state
        setData([]);  // Reset any related data
    };
    // Customer Selection


    // Route Selection -Filter


    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerId, setCustomerId] = useState('0');

    //FOR GET Route  Details FROM API
    const fetchCustomers = () => {
        fetchData('CustomerApi', `/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                // Transform the data into the format that react-select expects (label and value)
                const options = data.map((cust) => ({
                    label: cust.name,
                    value: cust.id,
                }));
                setCustomerOptions(options);
            })
            .catch((error) => {
                console.error('Error fetching customer data:', error);
            });
    };

    const handlecustomerSelect = (selectedOption) => {
        setSelectedCustomer(selectedOption);  // Set the selected option as state
        const customerId = selectedOption ? selectedOption.value : '';  // Extract executiveId from the selected option
        setCustomerId(customerId);  // Set executiveId state
        setData([]);  // Reset any related data
    };

    // Fetch table data
    const fetchTableData = async () => {

        setData([])
        setLoading(true);

        try {
            const response = await fetchData('ChequeSummaryAPI', `/${companyId}/${routeId}/${fromDate}/${toDate}/${customerId}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);


            }
        } catch (error) {
            console.error('Error fetching summary Details:', error);
        }
        finally {
            setLoading(false); // Hide loading screen
        };

    };



    const submitData = async (paymentid) => {
        try {
            // Retrieve the status ID for the current paymentid
            const statusId = selectedStatusType[paymentid].value;

            // Get the fine amount or default to null
            const fineAmount = fineAmounts[paymentid] || null;

            // Construct the formData object with all required fields
            const formData = {
                Id: paymentid,
                StatusId: statusId,  // Use the selected status ID for this payment
                ModifiedBy: userId,
                CompanyId: companyId,
                ModifiedDate: new Date(),
                chequefine: fineAmount, // Include the fine amount
            };

            // Call the update API with the constructed data
            const response = await updateData('ChequeSummaryAPI', `${paymentid}`, formData, token);

            if (response.responseCode === '1111') {
                console.log('PaymentReceipt Updated successfully:', response);
                setSuccessMessage('Cheque Status Updated successfully!');
                setErrorMessage('');

                // Refresh the page after successful update
                window.location.reload();
                fetchTableData();
            } else {
                // Handle unexpected response
                setErrorMessage('PaymentReceipt Updated successfully:', response);
                // window.location.reload();
                fetchTableData();
            }
        } catch (error) {
            console.error('PaymentReceipt Update error:', error);
            setErrorMessage('Error updating payment status. Please try again later.');
        }
    };

    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }
    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(15); // Rows per page
    // Define initial column order
    const [columnOrder, setColumnOrder] = useState([
        'SL No',
        'Route',
        'Customer',
        'Customer Bank',
        'Cheque Date',
        'Cheque No',
        'Amount',
        'Bank Name',
        'Remark',
        'Cheque Fine',
        'Status',
        ''
    ]);
    // Process and paginate the data
    const processedData = filteredData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );


    // Handle page change
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page
    };

    // Function to handle drag start
    const handleDragStart = (e, index) => {
        e.dataTransfer.setData('columnIndex', index);
    };

    // Function to handle drag over
    const handleDragOver = (e) => {
        e.preventDefault(); // Allow drop
    };
    // Function to handle drop
    const handleDrop = (e, index) => {
        const draggedIndex = e.dataTransfer.getData('columnIndex');
        if (draggedIndex !== index) {
            const newOrder = [...columnOrder];
            // Swap columns
            [newOrder[draggedIndex], newOrder[index]] = [newOrder[index], newOrder[draggedIndex]];
            setColumnOrder(newOrder);
        }
    };


    const grandTotal = data
        .filter((row) => row) // Ensure `data` is filtered correctly (e.g., remove null or undefined entries)
        .reduce(
            (totals, rowData) => ({
                TotalCardAmount: parseFloat((totals.TotalCardAmount + (parseFloat(rowData.TotalCardAmount) || 0)).toFixed(2)),
                TotalCashAmount: parseFloat((totals.TotalCashAmount + (parseFloat(rowData.TotalCashAmount) || 0)).toFixed(2)),
                TotalUPIAmount: parseFloat((totals.TotalUPIAmount + (parseFloat(rowData.TotalUPIAmount) || 0)).toFixed(2)),
            }),
            {
                TotalCardAmount: 0,
                TotalCashAmount: 0,
                TotalUPIAmount: 0,
            }
        );
    return (
        <div className="w-full mx-auto" style={{ width: '95%', marginTop: '-1%' }}>
            <br />
            <div className="w-full mb-2 flex" style={{ marginTop: '10px', justifyContent: 'space-between' }}>
                <h6
                    className="uppercase tracking-wide text-black flex-grow linkcolor"
                    style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}
                >
                    Cheque Summary
                </h6>


                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', marginLeft: '10px' }}>
                    <div style={{ flexGrow: 1, display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                        <input
                            className="shadow text-gray-700 leading-tight"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            style={{
                                width: isFocused ? '270px' : '200px',
                                height: '40px',
                                border: '1px solid #ccc',
                                borderRadius: '15px',
                                padding: '0 20px',
                                transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                                outline: 'none',
                                borderColor: isFocused ? 'darkcyan' : '#ccc',
                                boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            }}
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '40%' }}>
                        <div style={{ maxWidth: '150px', marginRight: '10px', marginTop: '-15px' }}>
                            <label
                                className="block uppercase tracking-wide text-black text-xs font-bold mb-2"
                                htmlFor="fromDate"
                            >
                                FromDate
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date"
                                value={fromDate}
                                onChange={handleFromDateChange}
                            />
                        </div>
                        <div style={{ maxWidth: '150px', marginRight: '10px', marginTop: '-15px' }}>
                            <label
                                className="block uppercase tracking-wide text-black text-xs font-bold mb-2"
                                htmlFor="toDate"
                            >
                                ToDate
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date"
                                value={toDate}
                                onChange={handleToDateChange}
                            />
                        </div>

                    </div>
                    <Button
                        style={{
                            backgroundColor: '#C9E9D2',
                            color: 'black',
                            height: '36px',
                            marginTop: '15px'

                        }}
                        onClick={fetchTableData}
                        className="linkcolor"
                    >
                        <span>Refresh</span>
                    </Button>

                </div>
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '540px', overflowY: 'auto', marginTop: '-0.20%' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: 'whitesmoke', width: '2500px' }}>
                            <TableRow>
                                {columnOrder.map((col, index) => (
                                    <TableCell
                                        key={index}
                                        style={{
                                            padding: '6px',
                                            cursor: 'move',
                                            color: '#640D5F',
                                            fontWeight: 'bold',

                                        }}
                                        draggable
                                        onDragStart={(e) => handleDragStart(e, index)}
                                        onDragOver={handleDragOver}
                                        onDrop={(e) => handleDrop(e, index)}
                                    >
                                        {col}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {processedData.map((rowData, index) => {
                                const rowValues = {
                                    'SL No': index + 1,
                                    Route: rowData.RouteName || '',
                                    Customer: rowData.partyname || '',
                                    'Customer Bank': rowData.Chequedescription || '',
                                    'Cheque Date': rowData.ChequeDate ? formatDate(rowData.ChequeDate) : '',
                                    'Cheque No': rowData.ChequeNo || '',
                                    Amount: rowData.ChequeAmount ? parseFloat(rowData.ChequeAmount).toFixed(2) : '0.00',
                                    'Bank Name': rowData.BankDetails || '',
                                    Remark: rowData.Remarks || '',
                                    'Cheque Fine': rowData.chequefine ? parseFloat(rowData.chequefine).toFixed(2) : '0.00',

                                };

                                const isReadOnly = rowData.chequefine > 0;

                                return (
                                    <React.Fragment key={index}>
                                        {/* Main Row */}

                                        <TableRow
                                            style={{
                                                backgroundColor: isReadOnly ? '#ECDFCC' : 'inherit',
                                            }}
                                        >
                                            {Object.keys(rowValues).map((key) => (
                                                <TableCell key={key}>{rowValues[key]}</TableCell>
                                            ))}


                                            <TableCell sx={{ padding: '3px', width: '9%' }}>
                                                <Select
                                                    value={
                                                        statusOptions.find(
                                                            (option) =>
                                                                option.value === selectedStatusType[rowData.paymentid]?.value
                                                        ) || { value: rowData.chequeStatus, label: rowData.chequeStatus }
                                                    }
                                                    onChange={(selectedOption) =>
                                                        handleStatusTypeChange(selectedOption, rowData.paymentid)
                                                    }
                                                    options={[
                                                        { value: rowData.chequeStatus, label: rowData.chequeStatus },
                                                        ...statusOptions,
                                                    ]}
                                                    placeholder="Status Options"
                                                    isSearchable
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        menu: (base) => ({ ...base, maxHeight: '200px', overflowY: 'auto' }),
                                                    }}
                                                />
                                            </TableCell>

                                            {/* </TableRow> */}

                                            {/* Fine Input Row (conditionally render if status is 'Rejected') */}
                                            {/* {selectedStatusType[rowData.paymentid]?.label === 'Rejected' && (

                                                <TableCell colSpan={columnOrder.length - 1} sx={{ padding: '3px', width: '12%' }}>
                                                    <input
                                                        type="text"
                                                        placeholder="Enter Cheque Fine"
                                                        value={fineAmounts[rowData.paymentid] || ''}
                                                        onChange={(e) => handleFineAmountChange(rowData.paymentid, e.target.value)}
                                                        style={{
                                                            width: '55%',
                                                            padding: '3px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '4px',
                                                        }}
                                                    />

                                                    {
                                                        (selectedStatusType[rowData.paymentid]?.label === 'Rejected' ||
                                                            selectedStatusType[rowData.paymentid]?.label === 'Passed') && (
                                                            <SaveIcon
                                                                onClick={() => submitData(rowData.paymentid)}
                                                                style={{ color: 'green', marginLeft: '10px' }}
                                                            />
                                                        )
                                                    }


                                                </TableCell>
                                            )}
 */}

                                            {selectedStatusType[rowData.paymentid]?.label === 'Rejected' && (
                                                <TableCell colSpan={columnOrder.length - 1} sx={{ padding: '3px', width: '12%' }}>
                                                    {/* Show fine amount input only for 'Rejected' */}
                                                    <input
                                                        type="text"
                                                        placeholder="Enter Cheque Fine"
                                                        value={fineAmounts[rowData.paymentid] || ''}
                                                        onChange={(e) => handleFineAmountChange(rowData.paymentid, e.target.value)}
                                                        style={{
                                                            width: '55%',
                                                            padding: '3px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '4px',
                                                        }}
                                                    />
                                                </TableCell>
                                            )}

                                            {/* Show Save icon for both 'Rejected' and 'Passed' */}
                                            {(selectedStatusType[rowData.paymentid]?.label === 'Rejected' ||
                                                selectedStatusType[rowData.paymentid]?.label === 'Passed') && (
                                                    <TableCell>
                                                        <SaveIcon
                                                    onClick={() => submitData(rowData.paymentid)}
                                                    style={{ color: 'green', marginLeft: '10px' }}
                                                />
                                           </TableCell>
                                            )}
                                                    


                                            {/* <SaveIcon onClick={() => submitData(rowData.paymentid)} style={{ color: 'green', marginLeft: '10px' }} /> */}
                                        </TableRow>
                                    </React.Fragment>
                                );
                            })}
                        </TableBody>

                        {/* Render Grand Total in Footer */}
                        <TableFooter style={{ padding: '5px' }}>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[15, 25, 50, 100]}
                                    count={filteredData.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handlePageChange}
                                    onRowsPerPageChange={handleRowsPerPageChange}

                                />
                            </TableRow>


                        </TableFooter>
                    </Table>
                </TableContainer>
            </div>
        </div >
    );
}


export default ChequeStatus;